export const isNullOrUndefined = (any: any) => any === null || any === undefined;
